import { http } from '../http';

export interface Cor {
  codigo_cor: string;
  descricao: string;
  situacao: string;
}

export interface CorResponse {
  total: number;
  page: number;
  limit: number;
  items: Cor[];
}

export const fetchSgaCores = async (
  page: number = 1,
  limit: number = 10
): Promise<CorResponse> => {
  const response = await http.get('/sga-cor/listar', {
    params: { page, limit },
  });

  return response.data;
};
